export const localization = {
  pt: {
    actions: {
      delete: 'Excluir',
    },
    errors: {
      failedToLoadContent: 'Falha ao carregar conteúdo do documento',
    },
  },
  en: {
    actions: {
      delete: 'Delete',
    },
    errors: {
      failedToLoadContent: 'Failed to load document content',
    },
  },
  es: {
    actions: {
      delete: 'Eliminar',
    },
    errors: {
      failedToLoadContent: 'Error al cargar el contenido del documento',
    },
  },
};
